<template>
	<div>
<!--		<breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'redis缓存清理'}]"/>-->
    <Breadtabsheader/>
		<div class="h-content ljjredismanager">
			<div class="h-piece">
				<div class="el-table el-table--fit el-table--striped el-table--scrollable-x el-table--enable-row-transition">
					<table style="width:100%">
						<tr>
							<td>redis的key</td>
							<td>操作</td>
						</tr>
						<tr v-for="o,i in keys">
							<td>{{o}}</td>
							<td @click="clearkey(o)">
								<a href="javascript:;" style="color: #1c84c6;">删除</a></td>
						</tr>
					</table>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
   import ss from '../../api/SystemService'
    export default {
        data() {
            return {
                keys:null,

            }
        },
        created() {
            this.loadkeys();
        },
        methods: {
            loadkeys(){
                ss.RedisService.list().then(rd=>{
                    this.keys = rd.obj;
				})
			},
			clearkey(key){
                this.$msg.confirm("确认删除？",()=>{
                    ss.RedisService.clearkey(key).then(rd=>{
                        this.loadkeys();
                    })
				})
			}
        }
    }
</script>
<style>
	.ljjredismanager .el-table tr:last-child td{
		border: none;
	}
</style>